import DOMPurify from "dompurify";

/**
 * The HTML a Word or Excel package document was converted to, made safe to render.
 *
 * The server already strips the obvious active content, but the markup comes from an uploaded
 * file and is shown with dangerouslySetInnerHTML, so it is sanitised here, at the point of use,
 * by DOMPurify rather than trusted. The converters (mammoth, SheetJS) emit headings, paragraphs,
 * lists, tables and links — nothing else is needed, so forms, embeds and inline styles go too.
 */
export function sanitizePreviewHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ["style", "form", "input", "button", "textarea", "select", "iframe", "object", "embed"],
    FORBID_ATTR: ["style"],
  });
}
